import React, { PureComponent } from "react";

import { track } from './posthog';
import { withRouter } from "react-router-dom";

import "./DataForm.css";

/*
  Formulaire de coordonnées du récapitulatif — inputs HTML natifs stylés par
  tokens (ex-Material-UI v4, retiré au lot C de la refonte DesignB2B).

  CONTRAT DOM À NE JAMAIS CASSER :
  - ids `details / prenom / name / email / phone / site / checkbox` et
    `name="checkbox"` : lus par validateForm, RecapPage.sendDevis
    (event.target.X.value) et scrollVersPremierChampBloquant ;
  - onFocus / onBlur de chaque champ : events PostHog
    devis_recap_formulaire_demarre et devis_recap_champ_saisi.
*/

const ICONE_UTILISATEUR = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const ICONE_EMAIL = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4"></circle>
    <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>
  </svg>
);

const ICONE_TELEPHONE = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const ICONE_BOUTIQUE = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 21h18"></path>
    <path d="M5 21V7l7-4 7 4v14"></path>
    <path d="M9 9h1"></path>
    <path d="M14 9h1"></path>
    <path d="M9 13h1"></path>
    <path d="M14 13h1"></path>
  </svg>
);

const sites = [
  {value: 1, label: 'Vitré (35500)'},
  {value: 4, label: 'Laval (53000)'},
  {value: 5, label: 'Rennes (35000)'}
];

// Validation email unique, identique à celle utilisée pendant la saisie
// (handleEmailChange) : l'ancienne regex stricte refusait des adresses
// légitimes (le « + » notamment) que le champ affichait pourtant comme valides.
const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Validation téléphone sur les chiffres bruts (espaces retirés) plutôt que sur
// la chaîne formatée « 0X XX XX XX XX » : moins fragile si le formatage évolue.
const validPhone = /^0[1-9][0-9]{8}$/;


// Longueur maximale de la zone « Votre demande ». Doit rester alignée sur
// LONGUEUR_MAX_COMMENTAIRE_LIGNE côté API (features/module_devis/repository.js),
// qui tronque au-delà. Sans cette limite, une saisie longue faisait échouer
// l'enregistrement du commentaire (Sentry PHONER-S1).
const LONGUEUR_MAX_DETAILS = 2000;

// Champs du formulaire de coordonnées, dans l'ordre d'affichage. Seuls les NOMS
// de champs sont envoyés à l'analytics — jamais les valeurs saisies (RGPD).
const CHAMPS_FORMULAIRE = ['details', 'prenom', 'nom', 'email', 'telephone', 'boutique', 'consentement'];

// Correspondance champ logique -> id DOM, pour faire défiler la page jusqu'à la
// première erreur (l'ordre suit CHAMPS_FORMULAIRE, pas l'ordre de validation).
const ID_DOM_PAR_CHAMP = {
  prenom: 'prenom',
  nom: 'name',
  email: 'email',
  telephone: 'phone',
  boutique: 'site',
  consentement: 'checkbox',
};

class DataForm extends PureComponent {
  constructor(props) {
    super(props);
    this.validateForm = this.validateForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleChampFocus = this.handleChampFocus.bind(this);
    this.handleChampBlur = this.handleChampBlur.bind(this);

    // Suivi de progression dans le formulaire, hors state React : ces valeurs ne
    // déclenchent aucun rendu, elles servent uniquement à l'analytics et à
    // l'event de sortie émis par RecapPage.
    this.formulaireDemarre = false;
    this.champsVus = {};      // champs sur lesquels l'utilisateur a déjà cliqué
    this.champsRemplis = {};  // champs quittés avec une valeur non vide
    this.nbTentatives = 0;    // nombre de clics sur « Voir le tarif »

    this.state = {
      name: "",
      email: "",
      phoneNumber: "",
      site: "",
      emailHelperText: '',
      emailError: false ,
      nameHelperText: '',
      nameHelper: false,
      prenomHelperText: '',
      prenomError: false,
      phoneNumberHelperText: '',
      phoneNumberHelper: false,
      isErrorChecked : false,
      isSubmitting: false,
      erreurEnvoi: false,
      longueurDetails: 0,
    };

  }


  // Sur mobile, le bouton d'envoi est en bas de page : une erreur affichée plus
  // haut est invisible et l'utilisateur croit que rien ne se passe. On amène
  // donc la première erreur (dans l'ordre d'affichage) au centre de l'écran.
  scrollVersPremierChampBloquant(champsBloquants) {
    const premierChamp = CHAMPS_FORMULAIRE.find(
      (champ) => champsBloquants.indexOf(champ) >= 0
    );
    if (!premierChamp) {
      return;
    }
    const element = document.getElementById(ID_DOM_PAR_CHAMP[premierChamp]);
    if (!element) {
      return;
    }
    if (typeof element.scrollIntoView === 'function') {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    // Le scroll seul ne suffit pas quand le champ fautif est déjà visible (cas
    // de la case de consentement, juste au-dessus du bouton) : sans focus,
    // l'utilisateur ne voit rien bouger et croit que le clic n'a pas marché.
    if (typeof element.focus === 'function') {
      try {
        element.focus({ preventScroll: true });
      } catch (e) {
        element.focus();
      }
    }
  }

  // Remonte l'avancement du formulaire au parent (RecapPage), qui s'en sert pour
  // qualifier l'abandon au moment où l'utilisateur quitte la page.
  notifierEtat() {
    if (typeof this.props.onEtatFormulaire === 'function') {
      this.props.onEtatFormulaire({
        formulaire_demarre: this.formulaireDemarre,
        champs_remplis: Object.keys(this.champsRemplis),
        nb_tentatives: this.nbTentatives,
      });
    }
  }

  // Premier contact avec le formulaire : marque le début de la saisie.
  handleChampFocus(champ) {
    if (!this.formulaireDemarre) {
      this.formulaireDemarre = true;
      track('devis_recap_formulaire_demarre', { champ_premier: champ });
    }
    this.champsVus[champ] = true;
    this.notifierEtat();
  }

  // Sortie d'un champ : on note s'il a été rempli, jamais ce qu'il contient.
  // Un seul event par champ, sur la première sortie, pour éviter le bruit.
  handleChampBlur(champ, event) {
    const valeur = event && event.target ? event.target.value : '';
    const rempli = String(valeur || '').trim().length > 0;

    if (rempli) {
      this.champsRemplis[champ] = true;
    } else {
      delete this.champsRemplis[champ];
    }

    if (!this.champsQuittes) {
      this.champsQuittes = {};
    }
    if (!this.champsQuittes[champ]) {
      this.champsQuittes[champ] = true;
      track('devis_recap_champ_saisi', {
        champ: champ,
        rempli: rempli,
        rang: CHAMPS_FORMULAIRE.indexOf(champ),
      });
    }

    this.notifierEtat();
  }

  addTextArea() {
    /* on ajoute une zone de texte si details = 1 cad si la demande est "autre" */
    if(this.props.details)
      return(
        <div className="df-field">
          <label className="df-label" htmlFor="details">Votre demande</label>
          <div className="df-input-wrap df-textarea-wrap">
            <textarea
              id="details"
              rows={4}
              maxLength={LONGUEUR_MAX_DETAILS}
              onChange={(event) => this.setState({longueurDetails: event.target.value.length})}
              onFocus={() => this.handleChampFocus('details')}
              onBlur={(event) => this.handleChampBlur('details', event)}/>
          </div>
          <p className="df-helper">
            Saisir votre demande avec le plus de détails possibles
            {' '}({this.state.longueurDetails}/{LONGUEUR_MAX_DETAILS} caractères)
          </p>
        </div>
      );
  }



  // Même regex que la validation à la soumission (validEmail) : un email
  // affiché comme valide pendant la saisie ne doit jamais être refusé au clic.
  validateEmail = (email) => {
    return validEmail.test(email);
  };


  // Un champ vide et un champ mal saisi sont deux situations différentes, pour
  // l'utilisateur comme pour l'analytics :
  //  - `manquants` : rien n'a été saisi, la case n'est pas cochée, la boutique
  //    n'est pas choisie. L'utilisateur n'a pas fini, il n'a commis aucune faute.
  //  - `invalides` : une valeur est présente mais refusée par la règle de format.
  // Les mélanger noyait les rares saisies réellement rejetées (une trentaine par
  // mois) sous les formulaires simplement incomplets (une bonne vingtaine par
  // jour), et faisait afficher « Adresse email invalide » sur un champ vide.
  async validateForm(event) {
    event.preventDefault();
    var error = 0;
    const manquants = [];
    const invalides = [];

    this.nbTentatives = this.nbTentatives + 1;

    const email = event.target.email.value.trim();
    if (email.length === 0) {
      manquants.push('email');
      this.setState({
        emailHelperText: 'Veuillez saisir votre adresse email.',
        emailError: true });
      error = 1;
    }
    else if (!validEmail.test(email)) {
      invalides.push('email');
      this.setState({
        emailHelperText: 'Adresse email invalide, ex : adresse@monmail.com',
        emailError: true });
      error = 1;
    }

    else {
      this.setState({
        emailHelperText: '',
        emailError: false });
    }

    const telephone = event.target.phone.value.replace(/\s+/g, '');
    if (telephone.length === 0) {
      manquants.push('telephone');
      this.setState({
        phoneNumberHelperText: 'Veuillez saisir votre numéro de téléphone.',
        phoneNumberError: true });
      error = 1;
    }
    else if (!validPhone.test(telephone)) {
      invalides.push('telephone');
      this.setState({
        phoneNumberHelperText: 'Numéro invalide : saisir 10 chiffres, ex : 06 12 34 56 78',
        phoneNumberError: true });
      error = 1;
    }

    else {
      this.setState({
        phoneNumberHelperText: '',
        phoneNumberError: false });
    }

    const prenom = event.target.prenom.value.trim();
    if (prenom.length === 0) {
      manquants.push('prenom');
      this.setState({
        prenomHelperText: 'Veuillez saisir votre prénom.',
        prenomError: true });
      error = 1;
    }
    else if (prenom.length < 2) {
      invalides.push('prenom');
      this.setState({
        prenomHelperText: 'Veuillez saisir votre prénom (2 caractères minimum).',
        prenomError: true });
      error = 1;
    }
    else {
      this.setState({
        prenomHelperText: '',
        prenomError: false });
    }

    const nom = event.target.name.value.trim();
    if (nom.length === 0) {
      manquants.push('nom');
      this.setState({
        nameHelperText: 'Veuillez saisir votre nom.',
        nameError: true });
      error = 1;
    }
    else if (nom.length < 2) {
      invalides.push('nom');
      this.setState({
        nameHelperText: 'Veuillez saisir votre nom (2 caractères minimum).',
        nameError: true });
      error = 1;
    }
    else {
      this.setState({
        nameHelperText: '',
        nameError: false });
    }

    // Boutique et consentement n'ont pas de cas « invalide » : soit c'est fait,
    // soit ça ne l'est pas. Ils ne peuvent donc être que manquants.
    // Parenthèses volontaires : `!this.state.site > 0` était évalué
    // `(!site) > 0`, correct par accident seulement.
    if(!(this.state.site > 0)) {
      manquants.push('boutique');
      this.setState({
        SiteHelperText: 'Sélectionner une boutique.',
        SiteError: true });
      error = 1;
    }  else {
        this.setState({
          SiteHelperText: '',
          SiteError: false });
      }

    if(!event.target.checkbox.checked){
      error = 1;
      manquants.push('consentement');
      this.setState({isErrorChecked : true})
    }else{
      this.setState({isErrorChecked : false})
    }

    if(manquants.length > 0 || invalides.length > 0) {
      track('devis_soumission_bloquee', {
        champs_manquants: manquants,
        champs_invalides: invalides,
        nb_manquants: manquants.length,
        nb_invalides: invalides.length,
        tentative: this.nbTentatives,
      });
      this.scrollVersPremierChampBloquant(manquants.concat(invalides));
    }

    this.notifierEtat();

    if(!error){
        this.setState({ isSubmitting: true, erreurEnvoi: false });
        try {
          await this.props.onSubmit(event, this.state.site);
          this.props.history.push('/recapitulatif/final');
        } catch (e) {
          // Blocage volontaire décidé par le récapitulatif (code de réduction
          // saisi mais non vérifié) : le message utile est déjà affiché sous le
          // champ concerné, l'erreur générique d'envoi induirait en erreur.
          if(e && e.blocageUtilisateur) {
            this.setState({ isSubmitting: false, erreurEnvoi: false });
            return;
          }

          // Échec d'envoi (réseau, serveur, réponse invalide) : on informe
          // l'utilisateur et on réactive le bouton pour permettre un nouvel essai.
          console.error('Erreur lors de l\'envoi du devis:', e);
          this.setState({ isSubmitting: false, erreurEnvoi: true });
        }
    }

  }

  handlePhoneChange = ({target: {value }}) => {
    value = value
      // Retire TOUS les caractères non numériques (flag g) : sans lui, seul le
      // premier groupe était retiré, et un numéro collé au format 06.12.34.56.78
      // gardait ses séparateurs -> échec de validPhone à la soumission.
      .replace(/\D+/g, '')
      // Indicatif France sous les trois formes collées depuis un contact :
      // « +33 6… », « 0033 6… » et « 33 6… » -> « 06… ». Sans le cas 0033, le
      // numéro gardait ses 13 chiffres et validPhone le refusait à la soumission.
      .replace(/^(?:0033|33)0?/, '0')
      // Un numéro français fait 10 chiffres, et validPhone n'en accepte pas plus :
      // tronquer ici rend le refus visible pendant la saisie plutôt qu'au clic.
      .slice(0, 10)
      // Add a space after any 2-digit group followed by more digits
      .replace(/(\d{2})(?=\d)/g, '$1 ')
    this.setState({
      phoneNumber: value
    })
  }

  handleChange(event) {
    // Le select n'émet pas de focus/blur exploitables : on traite le choix d'une
    // boutique comme un champ vu puis rempli.
    this.handleChampFocus('boutique');
    this.handleChampBlur('boutique', event);

    // Le select natif renvoie une chaîne : on conserve un nombre comme avec
    // l'ancien Select Material-UI (valeur transmise ensuite au serveur).
    this.setState({
      site: event.target.value === "" ? "" : Number(event.target.value)
    });
  }


  handleEmailChange = (e) => {
    let email = e.target.value;
    // Minuscules + suppression des espaces : les claviers mobiles ajoutent
    // souvent une espace finale par auto-complétion, invalidant l'adresse.
    email = email.toLowerCase().replace(/\s+/g, '');
    this.setState({ email });

    if (email === '') {
      this.setState({
        emailError: true,
        emailHelperText: 'L\'email est requis',
      });
    } else if (!this.validateEmail(email)) {
      this.setState({
        emailError: true,
        emailHelperText: 'Adresse email invalide',
      });
    } else {
      this.setState({
        emailError: false,
        emailHelperText: '',
      });
    }
  };



  render() {

    return (

      <form
        className="data-form"
        noValidate
        autoComplete="off"
        onSubmit={this.validateForm}>
        {this.addTextArea()}
        <hr className="df-separator"/>
        <div className="title-DataForm">Vos coordonées</div>

        <div className="df-field">
          <label className="df-label" htmlFor="prenom">Prénom <span className="df-required">*</span></label>
          <div className={"df-input-wrap" + (this.state.prenomError ? " df-input-error" : "")}>
            <span className="df-icon">{ICONE_UTILISATEUR}</span>
            <input
              id="prenom"
              type="text"
              placeholder="Prénom"
              onFocus={() => this.handleChampFocus('prenom')}
              onBlur={(event) => this.handleChampBlur('prenom', event)}/>
          </div>
          {this.state.prenomHelperText !== '' && <p className="df-error">{this.state.prenomHelperText}</p>}
        </div>

        <div className="df-field">
          <label className="df-label" htmlFor="name">Nom <span className="df-required">*</span></label>
          <div className={"df-input-wrap" + (this.state.nameError ? " df-input-error" : "")}>
            <span className="df-icon">{ICONE_UTILISATEUR}</span>
            <input
              id="name"
              type="text"
              placeholder="Nom"
              onFocus={() => this.handleChampFocus('nom')}
              onBlur={(event) => this.handleChampBlur('nom', event)}/>
          </div>
          {this.state.nameHelperText !== '' && <p className="df-error">{this.state.nameHelperText}</p>}
        </div>

        <div className="df-field">
          <label className="df-label" htmlFor="email">Adresse email <span className="df-required">*</span></label>
          <div className={"df-input-wrap" + (this.state.emailError ? " df-input-error" : "")}>
            <span className="df-icon">{ICONE_EMAIL}</span>
            <input
              id="email"
              type="email"
              placeholder="adresse@monmail.com"
              value={this.state.email}
              onChange={this.handleEmailChange}
              onFocus={() => this.handleChampFocus('email')}
              onBlur={(event) => this.handleChampBlur('email', event)}/>
          </div>
          {this.state.emailHelperText !== '' && <p className="df-error">{this.state.emailHelperText}</p>}
        </div>

        <div className="df-field">
          <label className="df-label" htmlFor="phone">Numéro de téléphone <span className="df-required">*</span></label>
          <div className={"df-input-wrap" + (this.state.phoneNumberError ? " df-input-error" : "")}>
            <span className="df-icon">{ICONE_TELEPHONE}</span>
            <input
              id="phone"
              type="tel"
              placeholder="06 12 34 56 78"
              value={this.state.phoneNumber}
              onChange={this.handlePhoneChange}
              onFocus={() => this.handleChampFocus('telephone')}
              onBlur={(event) => this.handleChampBlur('telephone', event)}/>
          </div>
          {this.state.phoneNumberHelperText !== '' && <p className="df-error">{this.state.phoneNumberHelperText}</p>}
        </div>

        <div className="df-field">
          <label className="df-label" htmlFor="site">Boutique <span className="df-required">*</span></label>
          <div className={"df-input-wrap" + (this.state.SiteError ? " df-input-error" : "")}>
            <span className="df-icon">{ICONE_BOUTIQUE}</span>
            <select
              id="site"
              value={this.state.site}
              onChange={this.handleChange}>
              <option value="" disabled>Sélectionner une boutique</option>
              {sites.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          {this.state.SiteError && <p className="df-error">{this.state.SiteHelperText}</p>}
        </div>

        <label
          className={this.state.isErrorChecked ? 'df-consent df-consent-error' : 'df-consent'}
          htmlFor="checkbox">
          <input
            type="checkbox"
            id="checkbox"
            name="checkbox"
            aria-invalid={this.state.isErrorChecked}
            aria-describedby="erreur-consentement"
            onChange={(event) => {
              this.handleChampFocus('consentement');
              if (event.target.checked) {
                this.champsRemplis['consentement'] = true;
                // L'erreur disparaît dès que la case est cochée, sans attendre
                // un nouveau clic sur « Voir le tarif ».
                if (this.state.isErrorChecked) {
                  this.setState({isErrorChecked: false});
                }
              } else {
                delete this.champsRemplis['consentement'];
              }
              this.notifierEtat();
            }}/>
          <span>J'accepte que les données saisies soient utilisées dans le cadre de ma demande de devis et de la relation commerciale qui peut en découler</span>
        </label>

        <div>
          {
            this.state.isErrorChecked &&
            <p className="df-error" id="erreur-consentement">
              Veuillez cocher la case ci-dessus pour nous autoriser
              à traiter votre demande de devis.
            </p>
          }
          {
            this.state.erreurEnvoi &&
            <p className="df-error">
              Une erreur est survenue lors de l'envoi de votre demande.
              Veuillez réessayer. Si le problème persiste, contactez-nous
              directement en boutique ou par téléphone.
            </p>
          }
          <button className="validate-button" type="submit" disabled={this.state.isSubmitting}>
            {this.state.isSubmitting ? 'Envoi en cours...' : 'Voir le tarif'}
          </button>
        </div>
      </form>

    );
  }
}

export default withRouter(DataForm);
